export const ROUTES = {
  dashboard: "/",
  materials: "/materials",
  models: "/models",
  configurators: "/",
  configurator: "/configurators/:id",
};
